import React from 'react';
import {Field, ErrorMessage} from 'formik';
import TextError from './TextError';

function Checkbox(props){
    const {label, id, name, onChange, ...rest} = props
    return(
        <div>
            {/* <div style={{display:'flex',flexDirection:'row'}}>
                <Field 
                    type="checkbox" 
                    name={name} 
                    onChange={onChange}
                    style={{display:'block', borderRadius:'3px', border:'1px solid black'}} 
                    {...rest}
                />
                <label htmlFor={name} style={{display:'block', width: '100%'}}>{label}</label>
            </div> */}
            <label htmlFor={name}>
              <Field 
                type="checkbox" 
                name={name} 
                style={{margin:7}}
                //onChange={onChange} 
                {...rest}
              />
              {label}
            </label>
            <ErrorMessage name={name} component={TextError} />
        </div>
    )
}

export default Checkbox
